import { Component, input } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-recommendation-item-chip',
  imports: [TranslatePipe, TooltipModule, IconV3Component],
  template: `
    <div class="chip">
      @if (type() === 'trainedUserOnly') {
        <div class="container" pTooltip="{{ 'RECOMMENDATION.TRAINED_ONLY_TOOLTIP' | translate }}">
          @if (isEditable()) {
            <geaui-icon-v3 file="16px_certificate" />
          } @else {
            <geaui-icon-v3 file="16px_warning-sign" />
          }
          <span>
            {{ 'RECOMMENDATION.TRAINED_USERS_ONLY' | translate }}
          </span>
          @if (!isEditable()) {
            <geaui-icon-v3 file="16px_c-info" />
          }
        </div>
      } @else {
        <div class="container" pTooltip="{{ 'RECOMMENDATION.WARRANTY_INVALIDATING_RISK_TOOLTIP' | translate }}">
          @if (isEditable()) {
            <geaui-icon-v3 file="16px_file-remove" />
          } @else {
            <geaui-icon-v3 file="16px_warning-sign" />
          }
          <span>
            {{ 'RECOMMENDATION.WARRANTY_INVALIDATING_RISK' | translate }}
          </span>
          @if (!isEditable()) {
            <geaui-icon-v3 file="16px_c-info" />
          }
        </div>
      }
    </div>
  `,
  styles: `
    :host {
      margin: auto;
      .chip .container {
        display: flex;
        margin: 0.5rem;
        gap: 0.5rem;
        align-items: center;
        span {
          color: #0303b8;
        }
      }
    }
  `,
})
export class RecommendationItemChipComponent {
  readonly isEditable = input.required<boolean>();
  readonly type = input.required<'trainedUserOnly' | 'warrantyInvalidatingRisk'>();
}
